import type { Scene } from '@lumen5/luminary';

/**
 * Reads a scene's raw scene-design config — the template's own defaults for every asset, before
 * anything the author changed. Returns null when the config can't be read (a Luminary without the
 * private accessor, or a design that fails to load) so callers skip the comparison rather than
 * crash.
 */
export function getSceneDesignConfig(scene: Scene): unknown {
    try {
        const root = scene.root as unknown as {
            _getSceneDesignConfig?: (sceneDesignId: string, aspectRatio: string) => unknown;
            aspectRatio: string;
        };
        if (typeof root._getSceneDesignConfig !== 'function') {
            return null;
        }
        return root._getSceneDesignConfig(scene.sceneDesign, root.aspectRatio);
    } catch {
        return null;
    }
}
